// extracted by mini-css-extract-plugin
export default {"new":"new--2WCZd","new--big":"new--big--3WEFO"};
    if(module.hot) {
      // 1747648156147
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  